/**
 * @generated SignedSource<<ada4e784f1bc3a10ee0860253effd012>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveAccountsInput = {
  ids: ReadonlyArray<string>;
};
export type RemoveAccountsMutation$variables = {
  input: RemoveAccountsInput;
};
export type RemoveAccountsMutation$data = {
  readonly removeAccounts: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly removed: ReadonlyArray<{
      readonly id: string;
    }>;
  };
};
export type RemoveAccountsMutation = {
  response: RemoveAccountsMutation$data;
  variables: RemoveAccountsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveAccountsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveAccountsPayload",
        "kind": "LinkedField",
        "name": "removeAccounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RemoveAccountsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "RemoveAccountsPayload",
        "kind": "LinkedField",
        "name": "removeAccounts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemovedNode",
            "kind": "LinkedField",
            "name": "removed",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "93a85297e6241c77c306a295249d6060",
    "id": null,
    "metadata": {},
    "name": "RemoveAccountsMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveAccountsMutation(\n  $input: RemoveAccountsInput!\n) {\n  removeAccounts(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    removed {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "892560410ddc092683eb9b3bf1e82f00";

export default node;
